module.exports = __webpack_public_path__ + "img/asclepius.9d70ae39.svg";